'use strict';

import Logger from './Logger'
import Analytics from 'helpers/analytics/analytics'

let DateInput = {

  validatable: function(element, options, maxDaysAgo) {
    const dayElement = document.getElementById(element.id + '--day');
    const monthElement = document.getElementById(element.id + '--month');
    const yearElement = document.getElementById(element.id + '--year');
    const isRequired = element.required === true;

    function addAnalyticsError(errorText) {
      if (!errorText && options.errorNode) {
        errorText = options.errorNode.innerHTML;
      }

      if (errorText.length > 0) {
        Analytics.addError(errorText, true);
      }
    }

    const validatableField = {
      focus: function() {
        dayElement.focus();
      },

      removeClass: function(currentClass) {
        dayElement.parentNode.classList.remove(currentClass);
        monthElement.parentNode.classList.remove(currentClass);
        yearElement.parentNode.classList.remove(currentClass);

      },

      replace: function(currentClass, newClass) {
        validatableField.removeClass(currentClass);

        dayElement.parentNode.classList.add(newClass);
        monthElement.parentNode.classList.add(newClass);
        yearElement.parentNode.classList.add(newClass);
      },

      showErrorMessage: function() {
        if (element.nextSibling) {
          element.parentNode.insertBefore(options.errorNode, element.nextSibling);
        } else {
          element.parentNode.appendChild(options.errorNode);
        }

        addAnalyticsError();
      },

      addAnalyticsError: addAnalyticsError,

      hideErrorMessage: function() {
        if (element.parentNode === options.errorNode.parentNode) {
          element.parentNode.removeChild(options.errorNode);
        }
      }
    };

    const incompleteMessage = element.getAttribute('data-incomplete-message');
    let requiresCorrection = false;
    if (options.errorNode) {
      options.errorNode.appendChild(document.createTextNode(incompleteMessage));
    }

    function isValid(text) {
      let valid = true;
      if (!element.disabled) {
        if (isRequired) {
          let parts = text.split('/');
          let day = parts[0];
          let month = parts[1];
          let year = parts[2];
          let date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
          const dateMakesSense = date.getFullYear() === parseInt(year) &&
            date.getMonth() === parseInt(month) - 1 &&
            date.getDate() === parseInt(day);
          let withinMaxDays = false;
          if (dateMakesSense) {
            let today = new Date().getTime();
            let diff = Math.ceil((today - date.getTime()) / (1000 * 3600 * 24));
            withinMaxDays = (diff >= 0) && (diff <= (maxDaysAgo + 1));
          }
          const dateBeforeOrOnToday = (dateMakesSense) ? (date <= new Date()) : false;

          valid = dateMakesSense && dateBeforeOrOnToday && withinMaxDays;
        } else {
          valid = text === '';
        }
      }

      return valid;
    }

    function validate(text) {
      if (isValid(text)) {
        options.onValid(validatableField);
      } else {
        options.onInvalid(validatableField);
      }
    }

    const changeListener = () => {
      if (element.value === '') {
        options.onClear(validatableField);
      } else {
        if (requiresCorrection) {
          options.onCorrection(validatableField);
          requiresCorrection = false;
        }

        validate(element.value);
      }
    };

    const blurListener = () => {
      if (element.value === '') {
        return;
      }

      if (isValid(element.value)) {
        options.onValid(validatableField)
      } else {
        options.onIncomplete(validatableField)
      }
    };

    element.addEventListener('change', blurListener);
    dayElement.addEventListener('change', changeListener);
    monthElement.addEventListener('change', changeListener);
    yearElement.addEventListener('change', changeListener);

    return {
      validateSubmission: function(form) {
        if (!isValid(element.value)) {
          requiresCorrection = true;
          options.onIncomplete(validatableField);
          form.stop(validatableField);
          return false;
        } else {
          return true;
        }
      },
      showErrorMessage: validatableField.showErrorMessage,
      hideErrorMessage: validatableField.hideErrorMessage,
      getValidationElement: () => element,
      getFocusElement: () => document.getElementById(`${element.id}--day`)
    };
  }
};

export default function ValidatableNeverKnowinglyUndersoldDateField(element, maxDaysAgo) {
  const logger = new Logger(`ValidatableKNUField:${element.id}`);

  function displayIncompleteErrorMessage(inputField) {
    logger.debug('displayIncompleteErrorMessage');
    inputField.replace('input--valid', 'input--invalid');
    inputField.showErrorMessage();
  }

  function removeErrorMessage(inputField) {
    logger.debug('removeErrorMessage');
    inputField.hideErrorMessage();
  }

  function displayValidField(inputField) {
    logger.debug('displayValidField');
    inputField.replace('input--invalid', 'input--valid');
    inputField.hideErrorMessage();
  }

  function createErrorNode(errorClass) {
    logger.debug('createErrorNode');
    const errorMessage = document.createElement('small');
    errorMessage.classList.add(errorClass);
    return errorMessage;
  }

  function clearValidation(inputField) {
    logger.debug('clearValidation');
    inputField.hideErrorMessage();
    inputField.removeClass('input--invalid');
    inputField.removeClass('input--valid');
  }

  return DateInput.validatable(element, {
    errorNode: createErrorNode('never-knowingly-undersold-error-msg'),
    onIncomplete: displayIncompleteErrorMessage,
    onCorrection: removeErrorMessage,
    onValid: displayValidField,
    onInvalid: displayIncompleteErrorMessage,
    onClear: clearValidation
  }, maxDaysAgo);
}

